<template>
    <input
        :id="`${id}-${option.id}`"
        v-model="model"
        class="radio-optio-input"
        :value="option.value"
        type="radio"
        :disabled
    />
</template>

<script setup lang="ts">
import type { RadioOption } from './Radio.vue'

const { disabled = false } = defineProps<{
    option:
        | RadioOption<string | boolean>
        | Readonly<RadioOption<string | boolean>>
    id: string
    disabled?: boolean
}>()

const model = defineModel<string | boolean | null | undefined>({
    required: true,
})
</script>

<style lang="scss" scoped>
.radio-optio-input {
    position: relative;
    top: 1px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid var(--grey-500);

    &:checked {
        &::after {
            position: absolute;
            top: 1px;
            left: 1px;
            display: inline-block;
            border-radius: inherit;
            content: '';
            width: 12px;
            height: 12px;
            background-color: var(--green);
        }
    }
}
</style>
